export default __webpack_public_path__ + "static/media/nav-home.4cf9cd7c.svg";